import NavigationalBar from '#/pages/static/NavigationalBar';
import SiteMapFooter from '#/pages/static/SiteMapFooter';

const StaticPageLayout: React.FC<StaticPageLayoutProps> = ({ children, isNavBarDisabled }) => {
  return (
    <div className="min-h-screen">
      {!isNavBarDisabled && (
        <div className="w-full">
          <NavigationalBar />
        </div>
      )}
      <main className="">
        {children}
        <footer>
          <SiteMapFooter />
        </footer>
      </main>
    </div>
  );
};
export type StaticPageLayoutProps = {
  children: React.ReactNode;
  isNavBarDisabled?: boolean;
};

export default StaticPageLayout;
